import styled from "styled-components";

export const InputFormContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
`;
